export const PositionDict: { [index: string]: string } = {
  shortStopper: 'SS',
  firstBaseman: '1B',
  secondBaseman: '2B',
  thirdBaseman: '3B',
  leftFielder: 'LF',
  centerFielder: 'CF',
  rightFielder: 'RF',
  pitcher: 'Pitcher',
  batter: 'Batter',
  catcher: 'Catcher',
  firstBase: 'Runner on 1',
  secondBase: 'Runner on 2',
  thirdBase: 'Runner on 3',
};
